import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../api/axiosInstance";

const AddEditRestaurantSubscriptionMaster = ({
  editingData,
  groupId,
  restId,
  onClose,
  onSuccess,
}) => {
  /* ================= USER ================= */
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const userId = storedUser?.userId || 0;

  /* ================= STATE ================= */
  const [form, setForm] = useState({
    id: "",
    subscriptionId: 0,
    groupId: groupId || "",
    restId: restId || "",
    transactionDate: "",
    validFrom: "",
    validTo: "",
    isActivePlan: true,
    status: true,
  });

  /* ================= REFS ================= */
  const transRef = useRef(null);
  const fromRef = useRef(null);
  const toRef = useRef(null);
  const activeRef = useRef(null);
  const statusRef = useRef(null);
  const saveRef = useRef(null);

  /* ================= LOAD EDIT ================= */
  useEffect(() => {
    if (editingData) {
      setForm({
        ...editingData,
        groupId: editingData.groupId || groupId,
        restId: editingData.restId || restId,
        transactionDate: editingData.transactionDate?.slice(0, 16) || "",
        validFrom: editingData.validFrom?.slice(0, 16) || "",
        validTo: editingData.validTo?.slice(0, 16) || "",
      });
    }
  }, [editingData, groupId, restId]);

  /* ================= AUTO FOCUS ================= */
  useEffect(() => {
    setTimeout(() => {
      transRef.current?.focus();
    }, 120);
  }, []);

  /* ================= KEY NAV ================= */
  const handleKeyDown = (e, nextRef, prevRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      nextRef?.current?.focus();
    }

    if (e.key === "Escape") {
      e.preventDefault();
      if (prevRef?.current) prevRef.current.focus();
      else onClose?.();
    }
  };

  /* ================= CHANGE ================= */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  /* ================= SAVE ================= */
  const handleSubmit = async () => {
    if (!groupId) {
      alert("Group not selected");
      return;
    }

    if (!restId) {
      alert("Restaurant not selected");
      return;
    }

    const payload = {
      ...form,
      groupId,
      restId,
      createdBy: userId,
      modifiedBy: userId,
    };

    if (!form.id) {
      delete payload.subscriptionId;
    }

    try {
      await axiosInstance.post(
        "/RestaurantSubscriptionMaster/UpsertSubscription",
        payload
      );

      onSuccess?.();
      onClose?.();
    } catch (err) {
      console.error("Save error:", err);
      alert("Failed to save");
    }
  };

  /* ================= UI ================= */
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-lg p-6 border">
        <h2 className="text-lg font-bold mb-5">
          {form.id ? "Edit Subscription" : "Add Subscription"}
        </h2>

        <div className="space-y-4">
          {/* Transaction Date */}
          <div>
            <label className="block text-sm font-medium mb-1">
              Transaction Date
            </label>
            <input
              ref={transRef}
              type="datetime-local"
              name="transactionDate"
              value={form.transactionDate}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, fromRef)}
              className="w-full border rounded-lg px-3 py-2"
            />
          </div>

          {/* Valid From */}
          <div>
            <label className="block text-sm font-medium mb-1">
              Valid From
            </label>
            <input
              ref={fromRef}
              type="datetime-local"
              name="validFrom"
              value={form.validFrom}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, toRef, transRef)}
              className="w-full border rounded-lg px-3 py-2"
            />
          </div>

          {/* Valid To */}
          <div>
            <label className="block text-sm font-medium mb-1">
              Valid To
            </label>
            <input
              ref={toRef}
              type="datetime-local"
              name="validTo"
              value={form.validTo}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, activeRef, fromRef)}
              className="w-full border rounded-lg px-3 py-2"
            />
          </div>

          {/* Active Plan */}
          <div className="flex items-center gap-2">
            <input
              ref={activeRef}
              type="checkbox"
              name="isActivePlan"
              checked={form.isActivePlan}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, statusRef, toRef)}
            />
            <label className="text-sm font-medium">
              Active Plan
            </label>
          </div>

          {/* Status */}
          <div className="flex items-center gap-2">
            <input
              ref={statusRef}
              type="checkbox"
              name="status"
              checked={form.status}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, saveRef, activeRef)}
            />
            <label className="text-sm font-medium">Active</label>
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-2 pt-3">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-lg bg-gray-500 text-white"
            >
              Cancel
            </button>

            <button
              ref={saveRef}
              onClick={handleSubmit}
              className="px-4 py-2 rounded-lg bg-blue-600 text-white"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEditRestaurantSubscriptionMaster;